import {
  NavigateFunction,
  type NavigateOptions,
  type To,
  useNavigate as useNavigateFn,
} from 'react-router';

export const useNavigate = (): NavigateFunction => {
  const navigate = useNavigateFn();

  const navigateWithViewTransition = (
    to: To | number,
    options?: NavigateOptions,
  ) => {
    if (typeof to === 'number') {
      return navigate(to);
    }

    return navigate(to, {
      viewTransition: true,
      ...(typeof options === 'object' ? options : {}),
    });
  };

  return navigateWithViewTransition as NavigateFunction;
};
